export default "__VITE_ASSET__SdiEZUAt__"